<template>
  <v-autocomplete
    v-model="CODIGO_SELECIONADO_COMPUTED"
    v-bind="$attrs"
    item-text="descricao"
    item-value="id"
    :items="items"
    v-on="inputListeners"
  />
</template>

<script>
import api from '@/api/api.js';
import {logout} from "@/helpers";

export default {
  name: "SysCodigosPagamentosAutocomplete",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: ['modelValue'],
  emits: ['update:modelValue'],
  data: () => ({
    items: [],
  }),
  computed: {
    CODIGO_SELECIONADO_COMPUTED: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit('update:modelValue', valor);
      }
    },
    inputListeners: function () {
      const vm = this

      return Object.assign({},
        vm.$listeners, {
          input: function (valor) {
            vm.CODIGO_SELECIONADO_COMPUTED = valor;
          }
        }
      )
    }
  },
  mounted() {
    this.buscarItens();
  },
  methods: {
    buscarItens() {
      api.get('codigos-pagamentos')
        .then(resposta => {
          this.items = resposta.data.codigos_pagamentos.map(item => ({
            id: item.id,
            descricao: `${item.id} - ${item.descricao.trim()}`
          }));
        })
        .catch(logout)
    }
  }
}
</script>
